import { useSelector } from "react-redux";
var useSelectors = function () {
    var _a = useSelector(function (state) { return ({
        responsePlans: state.Plans.responsePlans,
        errorPlans: state.Plans.errorPlans,
        loadingPlans: state.Plans.loadingPlans,
    }); }), responsePlans = _a.responsePlans, errorPlans = _a.errorPlans, loadingPlans = _a.loadingPlans;
    // const { responsePlan, errorPlan, loading } = useSelector((state: any) => ({
    //   responsePlan: state.Plan.responsePlan,
    //   errorPlan: state.Plan.errorPlan,
    //   loading: state.Plan.loadingPlan,
    // }));
    var _b = useSelector(function (state) { return ({
        responsePaymentMode: state.PaymentMode.responsePaymentMode,
        errorPaymentMode: state.PaymentMode.errorPaymentMode,
        loadingPaymentMode: state.PaymentMode.loadingPaymentMode,
    }); }), responsePaymentMode = _b.responsePaymentMode, errorPaymentMode = _b.errorPaymentMode, loadingPaymentMode = _b.loadingPaymentMode;
    var _c = useSelector(function (state) { return ({
        responseAllQuote: state.Quote.responseAllQuote,
        errorAllQuote: state.Quote.errorAllQuote,
        loadingAllQuote: state.Quote.loadingAllQuote,
    }); }), responseAllQuote = _c.responseAllQuote, errorAllQuote = _c.errorAllQuote, loadingAllQuote = _c.loadingAllQuote;
    var _d = useSelector(function (state) { return ({
        responseTravelPremiums: state.TravelPremiums.responseTravelPremiums,
        errorTravelPremiums: state.TravelPremiums.errorTravelPremiums,
        loadingTravelPremiums: state.TravelPremiums.loadingTravelPremiums,
    }); }), responseTravelPremiums = _d.responseTravelPremiums, errorTravelPremiums = _d.errorTravelPremiums, loadingTravelPremiums = _d.loadingTravelPremiums;
    return {
        responsePlans: responsePlans,
        errorPlans: errorPlans,
        loadingPlans: loadingPlans,
        responsePaymentMode: responsePaymentMode,
        errorPaymentMode: errorPaymentMode,
        loadingPaymentMode: loadingPaymentMode,
        responseAllQuote: responseAllQuote,
        errorAllQuote: errorAllQuote,
        loadingAllQuote: loadingAllQuote,
        responseTravelPremiums: responseTravelPremiums,
        errorTravelPremiums: errorTravelPremiums,
        loadingTravelPremiums: loadingTravelPremiums,
    };
};
export default useSelectors;
